import ExternalAudience from 'owa-service/lib/contract/ExternalAudience';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';

/**
 * Util to determine if Automatic replies text is different for internal and external senders.
 * @param autoReplyConfigOptions automatic replies options
 */
export default function isDifferentReplyForOrgAndExtSenders(
    autoReplyConfigOptions: MailboxAutoReplyConfigurationOptions
): boolean {
    // External audience is enabled and texts are different and only for enterprise
    if (
        !isConsumer() &&
        autoReplyConfigOptions.ExternalAudience !== ExternalAudience.None &&
        autoReplyConfigOptions.ExternalMessageText !== autoReplyConfigOptions.InternalMessageText
    ) {
        return true;
    }
    return false;
}
